// @ts-check
import { styled } from '@mui/material';
import { TextInput } from '../../../newComponents/TextInput';

export const StyledInput = styled(TextInput)(() => ({
  '& label:not(.MuiInputLabel-shrink)': {
    paddingLeft: '32px',
  },
}));
